/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  BillBatchPathParameters,
  BillDetailPathParameters,
  BillDownloadUrlPathParameters,
  BillListParams,
  BillRefreshPathParameters,
  RewardBillRequestDTO,
  TableDataInfo
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 刷新账单任务结果（出网查询微信侧进度）
 */
const billRefresh = (
    { taskPk }: BillRefreshPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/bill/refresh/${taskPk}`, method: 'POST'
    },
      );
    }
  /**
 * @summary 发起账单获取（出网调用微信，日账单/iOS月结/订单明细）
 */
const billFetch = (
    rewardBillRequestDTO: RewardBillRequestDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/bill/fetch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rewardBillRequestDTO
    },
      );
    }
  /**
 * @summary 查询账单下载任务详情（不含真实下载地址）
 */
const billDetail = (
    { taskPk }: BillDetailPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/bill/${taskPk}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 获取账单真实下载地址（校验是否已过期）
 */
const billDownloadUrl = (
    { taskPk }: BillDownloadUrlPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/bill/url/${taskPk}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 查询账单下载任务列表（不含真实下载地址）
 */
const billList = (
    params: BillListParams,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/reward/bill/list`, method: 'GET',
        params
    },
      );
    }
  /**
 * @summary 查询同批发起的全部账单（iOS月结按月展开）
 */
const billBatch = (
    { batchNo }: BillBatchPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/bill/batch/${batchNo}`, method: 'GET'
    },
      );
    }
  return {billRefresh,billFetch,billDetail,billDownloadUrl,billList,billBatch}};
export type BillRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['billRefresh']>>>
export type BillFetchResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['billFetch']>>>
export type BillDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['billDetail']>>>
export type BillDownloadUrlResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['billDownloadUrl']>>>
export type BillListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['billList']>>>
export type BillBatchResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['billBatch']>>>
